var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pb-0 pt-0",attrs:{"cols":"12","md":"12","lg":"12"}},[_c('el-simple-table',{attrs:{"items":_vm.dataList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }